import { BaseMediaClientError } from '../../models/errors';
export class RequestError extends BaseMediaClientError {
  constructor(reason, metadata, innerError) {
    super(reason, metadata, innerError);
  }

  // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
  /** Will be deprecated. Use the properties `reason` and `metadata` instead */
  get attributes() {
    const {
      reason,
      metadata: {
        method,
        endpoint,
        mediaRegion,
        mediaEnv,
        attempts,
        clientExhaustedRetries,
        statusCode,
        traceContext
      } = {},
      innerError
    } = this;
    return {
      reason,
      method,
      endpoint,
      mediaRegion,
      mediaEnv,
      attempts,
      clientExhaustedRetries,
      statusCode,
      metadata: {
        traceContext
      },
      innerError
    };
  }
}
export function isRequestError(err) {
  return err instanceof RequestError;
}